<template>
  <div v-if="loading" class="d-grid h-100 bg-dark" style="place-content: center">
    <IndeterminateSpinner class="h1 m-0 text-white"/>
  </div>
  <div v-else class="w-100 d-flex flex-grow-1">
    <PresentationControl/>
    <SideBar class="d-flex flex-grow-1 bg-dark" />
    <ConnectionIndicator />
  </div>
</template>

<script lang="ts">
import { mapActions, mapState} from "pinia";
import { defineComponent } from "vue";
import PresentationControl from "./PresentationControl.vue"
import visibility from "@/lib/visibility";
import SideBar from "./sidebar/SideBar.vue"
import ConnectionIndicator from "@/components/frontend/shared/ConnectionIndicator.vue";
import IndeterminateSpinner from "@/components/backend/live/IndeterminateSpinner.vue";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import { useVotingModulesStore } from "@/entrypoints/stores/voting_modules";
import { useServerConnectionStore } from "@/entrypoints/stores/server_connection";
import { useTimingStore } from "@/entrypoints/stores/timing";
import type { Slide } from "@/types";

export default defineComponent({
  name: "Live",
  components: { IndeterminateSpinner, ConnectionIndicator, SideBar, PresentationControl },
  data() {
    return { loading: true };
  },
  computed: {
    ...mapState(usePresentationStore, ["slides"]),
    ballotSlides() {
      return this.slides.filter((s: Slide) => s.type === "Slides::BallotSlide");
    },
    visible() {
      return visibility.visible;
    },
  },
  methods: {
    ...mapActions(usePresentationStore, ["updateStatus", "subscribeToElectionChannel"]),
    ...mapActions(useVotingModulesStore, ["updatePosts"]),
    ...mapActions(useServerConnectionStore, ["checkWebsocketConnection"]),
    ...mapActions(useTimingStore, ["checkTime"]),
  },
  watch: {
    visible: function(newState, _oldState) {
      if (newState) {
        this.updateStatus(true);
        this.updatePosts();
      }
    }
  },
  created() {
    this.checkTime();
  },
  mounted() {
    Promise.all([
      this.updateStatus(true),
      this.updatePosts(),
    ]).then(() => this.loading = false);
    this.subscribeToElectionChannel(true);

    this.connectiontimer = setInterval(() => {
      this.checkWebsocketConnection()
    }, 1000)
  },
  beforeUnmount() {
    clearInterval(this.connectiontimer);
  },
});
</script>
